import SYMPTOMS from 'modules/constants/booking/symptoms';
import { CompanyName } from 'modules/utils/ConfigUtils';

const EMERGENCY_SYMPTOMS = SYMPTOMS.SYMPTOMS;

export default {
  LOCATION_PREFERENCE_DIALOG_TYPOGRAPHY: [
    'Review the guidelines below and then book accordingly.',
    `In many situations, a video visit can be an excellent way to practice social distancing while getting the healthcare you need. At ${CompanyName}, we conduct thousands of video visits each day.`,
    'Not all issues can be properly diagnosed and treated via video visit, and it is possible that your provider will contact you to transition your video visit to an in-person visit.'
  ],
  LOCATION_PREFERENCE_DIALOG_TITLE_ONE: ['A video visit is recommended:'],
  LOCATION_PREFERENCE_DIALOG_TITLE_TWO: [
    'However, an in-person visit is required in the following situations (if urgent, call your provider to schedule or visit your local Instacare):'
  ],
  LOCATION_PREFERENCE_DIALOG_TITLE_THREE: [
    'Still uncertain about what option is best for you? Call your provider to discuss your situation further.'
  ],
  LOCATION_PREFERENCE_DIALOG_TITLE_FOUR: [SYMPTOMS.EMERGENCY_TITLE],
  LOCATION_PREFERENCE_DIALOG_SUBTITLE_LIST_ONE: [
    'If you are looking to see your provider for any of the following situations:'
  ],
  LOCATION_PREFERENCE_DIALOG_SUBTITLE_LIST_TWO: [
    'If you (or someone you live with) has potential COVID-19 symptoms:'
  ],
  LOCATION_PREFERENCE_DIALOG_SUBTITLE_LIST_THREE: [
    'If you (or someone you live with) is at high risk of complications from COVID-19:'
  ],
  LOCATION_PREFERENCE_LIST_ITEMS_ONE: [
    'Mental health visits',
    'Chronic disease follow-up',
    'Medicare annual wellness visits',
    'Acute and chronic conditions that require discussion and visualization but no hands-on exam or treatment',
    'Medication renewals that require a visit to review'
  ],
  LOCATION_PREFERENCE_LIST_ITEMS_TWO: [
    'Fever',
    'New or worsening cough',
    'Shortness of breath',
    'Body ache(s)',
    'Reduced sense of smell',
    'Sore throat',
    'Diarrhea',
    'Runny or stuffy nose'
  ],
  LOCATION_PREFERENCE_LIST_ITEMS_THREE: [
    'Over 60 years old',
    'Receiving chemotherapy or other treatments for cancer or other diseases',
    'Have had bone marrow transplant',
    'Who are on immunosuppressive medication that purposefully suppresses your immune system -- for example, treatment for rheumatoid arthritis',
    'Taking opioid medications'
  ],
  LOCATION_PREFERENCE_LIST_ITEMS_FOUR: [
    'Well child checks',
    'Routine physical exams',
    'Conditions or visits that require a treatment, such as an injection or vaccination',
    'Minor abdominal pain',
    'Minor allergic reaction',
    'Minor broken bones',
    'Minor cuts/lacerations',
    'Minor falls'
  ],
  LOCATION_PREFERENCE_LIST_ITEMS_FIVE: [...EMERGENCY_SYMPTOMS]
};
